import {ALL_CONFIGS_KEY} from "./app-consts";

const allConfigs = window[ALL_CONFIGS_KEY];
if (allConfigs) {
    let orbitServerPath = allConfigs.orbit.extraProperties.paths.server;
    if(!orbitServerPath.endsWith('/')) {
        orbitServerPath = orbitServerPath + '/';
    }
    /* eslint-disable-next-line no-undef */
    __webpack_public_path__ = orbitServerPath;
}

